const MetabaseComputationStatusEnum = {
  unverified: 'Metabase_MetabaseComputation_Field_Status_Inactive',
  verified: 'Metabase_MetabaseComputation_Field_Status_Active'
}

export { MetabaseComputationStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/metabase/enum/MetabaseComputationStatusEnum.js